import { ReactNode, useState } from "react";
import { useLocation } from "react-router-dom";
import { UserController } from "src/components/user";
import { ErrorHandler } from "src/abstracts/handleError";
import { ResetPasswordScreenForm } from "./sections/form";
import { ResetPasswordScreenResetPasswordRequested } from "./sections/reset-password-email-requested";

enum ResetPasswordScreenSectionKey {
  form = "form",
  resetPasswordEmailRequested = "resetPasswordEmailRequested",
}

export default function ResetPasswordScreen() {
  const location = useLocation();

  const [email, setEmail] = useState<string>(location.state?.email ?? "");
  const [sectionKey, setSectionKey] = useState<ResetPasswordScreenSectionKey>(
    ResetPasswordScreenSectionKey.form,
  );

  const onEmailChanged = (email: string) => {
    setEmail(email);
  };

  const onResetPasswordButtonClicked = async () => {
    try {
      await UserController.sendResetPasswordEmail({ email });
      setSectionKey(ResetPasswordScreenSectionKey.resetPasswordEmailRequested);
    } catch (e) {
      ErrorHandler.displayError(e);
    }
  };

  const buildSectionFromSectionKey = (
    sectionKey: ResetPasswordScreenSectionKey,
  ): ReactNode => {
    switch (sectionKey) {
      case ResetPasswordScreenSectionKey.form:
        return (
          <ResetPasswordScreenForm
            email={email}
            onEmailChanged={onEmailChanged}
            onResetPasswordButtonClicked={onResetPasswordButtonClicked}
          />
        );
      case ResetPasswordScreenSectionKey.resetPasswordEmailRequested:
        return <ResetPasswordScreenResetPasswordRequested />;
    }
  };

  return (
    <main className="flex flex-col desktop:flex-row w-full tablet:min-h-[100svh] desktop:h-[100svh] items-center justify-center overflow-hidden">
      {buildSectionFromSectionKey(sectionKey)}
    </main>
  );
}
